import { hexagramOverview } from './hexagramOverview'

export const trigramMap = {
  양양양: '乾',
  양양음: '兌',
  양음양: '離',
  양음음: '震',
  음양양: '巽',
  음양음: '坎',
  음음양: '艮',
  음음음: '坤',
}

export const hexagramNames = {
  乾乾: '乾(건)',
  兌乾: '夬(쾌)',
  離乾: '大有(대유)',
  震乾: '大壯(대장)',
  巽乾: '小畜(소축)',
  坎乾: '需(수)',
  艮乾: '大畜(대축)',
  坤乾: '泰(태)',
  乾兌: '履(리)',
  兌兌: '兌(태)',
  離兌: '睽(규)',
  震兌: '歸妹(귀매)',
  巽兌: '中孚(중부)',
  坎兌: '節(절)',
  艮兌: '損(손)',
  坤兌: '臨(림)',
  乾離: '同人(동인)',
  兌離: '革(혁)',
  離離: '離(리)',
  震離: '豐(풍)',
  巽離: '家人(가인)',
  坎離: '既濟(기제)',
  艮離: '賁(비)',
  坤離: '明夷(명이)',
  乾震: '無妄(무망)',
  兌震: '隨(수)',
  離震: '噬嗑(서합)',
  震震: '震(진)',
  巽震: '益(익)',
  坎震: '屯(둔)',
  艮震: '頤(이)',
  坤震: '復(복)',
  乾巽: '姤(구)',
  兌巽: '大過(대과)',
  離巽: '鼎(정)',
  震巽: '恆(항)',
  巽巽: '巽(손)',
  坎巽: '井(정)',
  艮巽: '蠱(고)',
  坤巽: '升(승)',
  乾坎: '訟(송)',
  兌坎: '困(곤)',
  離坎: '未濟(미제)',
  震坎: '解(해)',
  巽坎: '渙(환)',
  坎坎: '坎(감)',
  艮坎: '蒙(몽)',
  坤坎: '師(사)',
  乾艮: '遯(둔)',
  兌艮: '咸(함)',
  離艮: '旅(려)',
  震艮: '小過(소과)',
  巽艮: '漸(점)',
  坎艮: '蹇(건)',
  艮艮: '艮(간)',
  坤艮: '謙(겸)',
  乾坤: '否(부)',
  兌坤: '萃(췌)',
  離坤: '晉(진)',
  震坤: '豫(예)',
  巽坤: '觀(관)',
  坎坤: '比(비)',
  艮坤: '剝(박)',
  坤坤: '坤(곤)',
}

export const hexagramMap = Object.fromEntries(
  hexagramOverview.map((item) => [item.괘이름, item]),
)
